<script>
export default {
  name: 'RenderComponent',
  props: {
    /**
     * @description 传入的render函数
     */
    renderFunction: {
      type: Function,
      required: true
    },
    /**
     * @description 传入的scope
     */
    // eslint-disable-next-line vue/require-prop-types
    scope: {
      default: null
    }
  },
  render(h) {
    return this.renderFunction(h, this.scope)
  }
}
</script>
